<template>
  <div class="card">
    <div class="card-header">
      <p class="card-header-title">Navigation</p>
      <span class="icon has-text-info help-btn">
        <a href="https://theadmin.thecompagnie.eu/doc?bloc=Navigation" target="_blank"><i class="fa fa-question-circle"></i></a>
      </span>
    </div>
    <div class="card-content principal">
      <div class="content">
        <div class="card">
          <div class="card-header">
            <p class="card-header-title">Ajouter un lien</p>
            <span class="icon has-text-info help-btn">
              <a href="https://theadmin.thecompagnie.eu/doc?bloc=Ajouter%20un%20lien" target="_blank"><i class="fa fa-question-circle"></i></a>
            </span>
          </div>
          <div class="card-content">
            <div class="content">
              <div class="field">
                <label class="label">Nom</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Nom (ex: Posts)" v-model="name">
                </div>
              </div>
              <div class="field">
                <label class="label">Chemin</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Chemin (ex: /admin/posts)" v-model="path">
                </div>
              </div>
              <div class="field is-grouped">
                <div class="control">
                  <button v-if="action === 'new'" class="button is-info" @click="addLink">Ajouter</button>
                  <button v-if="action === 'edit'" class="button is-info" @click="updateLink">
                    Actualiser
                  </button>
                  <button v-if="action === 'new-sub'" class="button is-info" @click="appendSubLink">
                    Ajouter un sous-chemin
                  </button>
                  <button v-if="action === 'edit-sub'" class="button is-info" @click="updateSubLink">
                    Editer sous-chemin
                  </button>
                </div>
                <div class="control">
                  <button class="button" @click="clear">Annuler</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="card">
          <div class="card-header">
            <p class="card-header-title">Menu</p>
            <span class="icon has-text-info help-btn">
              <a href="https://theadmin.thecompagnie.eu/doc?bloc=Menu" target="_blank"><i class="fa fa-question-circle"></i></a>
            </span>
          </div>
          <div class="card-content">
            <div class="content">
              <ul v-for="(item, index) in menu" :key="index" class="nav-preview">
                <li>
                  {{item.name}}: {{item.path}}
                  <span class="link-actions">
                    <span class="has-text-danger fa fa-trash" @click="removeLink(item)"></span>
                    <span v-if="index !== 0" class="has-text-success fa fa-arrow-up" @click="moveLinkUp(item, menu[index - 1])"></span>
                    <span v-if="index !== menu.length - 1" class="fa fa-arrow-down" @click="moveLinkDown(item, menu[index + 1])"></span>
                    <span class="has-text-info fa fa-edit" @click="editLink(item)"></span>
                    <span class="has-text-primary fa fa-plus" @click="addSubLink(item)"></span>
                  </span>

                  <!-- render children links -->
                  <ul v-if="item.children" class="sub-nav-preview">
                    <li v-for="(child, key) in item.children" :key="key">
                      {{child.name}}: {{child.path}}
                      <span class="sub-link-actions">
                        <span class="has-text-danger fa fa-trash" @click="removeSubLink(key, item)"></span>
                        <span class="has-text-success fa fa-arrow-up" @click="moveSubLinkUp(key, item)"></span>
                        <span class="fa fa-arrow-down" @click="moveSubLinkDown(key, item)"></span>
                        <span class="has-text-info fa fa-edit" @click="editSubLink(key, item)"></span>
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { settingsRef, navRef } from '@/admin/firebase_config'
export default {
  data () {
    return {
      key: '',
      link: '', // {'.key', name, path}
      name: '',
      path: '',
      action: 'new'
    }
  },
  computed: {
    isAbsolute () {
      return this.path.startsWith('http')
    }
  },
  firebase: {
    settings: {
      source: settingsRef,
      asObject: true
    },
    menu: {
      source: navRef
    }
  },
  methods: {
    addLink () {
      if (this.name && this.path) {
        this.$firebaseRefs.menu.push({
          name: this.name,
          path: this.path,
          isAbsolute: this.isAbsolute
        })
      }
      this.clear()
    },
    editLink (link) {
      this.name = link.name
      this.path = link.path
      this.action = 'edit'
      this.key = link['.key']
      this.link = Object.assign({}, link)
    },
    updateLink () {
      delete this.link['.key']
      this.link.name = this.name
      this.link.path = this.path
      this.link.isAbsolute = this.isAbsolute

      this.$firebaseRefs.menu.child(this.key).set(this.link)
      this.clear()
    },
    removeLink (item) {
      this.$firebaseRefs.menu.child(item['.key']).remove()
    },
    clear () {
      this.name = ''
      this.path = ''
      this.action = 'new'
    },
    moveLinkUp (item, previousItem) {
      let itemCopy = Object.assign({}, item)
      let previousItemCopy = Object.assign({}, previousItem)

      delete itemCopy['.key']
      delete previousItemCopy['.key']

      this.$firebaseRefs.menu.child(item['.key']).set(previousItemCopy)
      this.$firebaseRefs.menu.child(previousItem['.key']).set(itemCopy)
    },
    moveLinkDown (item, nextItem) {
      let itemCopy = Object.assign({}, item)
      let nextItemCopy = Object.assign({}, nextItem)

      delete itemCopy['.key']
      delete nextItemCopy['.key']

      this.$firebaseRefs.menu.child(item['.key']).set(nextItemCopy)
      this.$firebaseRefs.menu.child(nextItem['.key']).set(itemCopy)
    },
    addSubLink (link) {
      this.action = 'new-sub'
      this.key = link['.key']
    },
    appendSubLink () {
      this.$firebaseRefs.menu.child(this.key).child('children').push({
        name: this.name,
        path: this.path,
        isAbsolute: this.isAbsolute
      })
      this.clear()
    },
    moveSubLinkUp (currentKey, parent) {
      let childrenObject = {}
      let childrenArray = this.convertFirebaseObjToArray(parent.children)
      let previousKey = ''

      for (let i = 0; i < childrenArray.length; i++) {
        if (childrenArray[i]['.key'] === currentKey) {
          previousKey = childrenArray[i - 1]['.key']

          childrenObject[previousKey] = {...childrenArray[i]}
          childrenObject[currentKey] = {...childrenArray[i - 1]}

          delete childrenObject[previousKey]['.key']
          delete childrenObject[currentKey]['.key']
        } else {
          childrenObject[childrenArray[i]['.key']] = {...childrenArray[i]}
          delete childrenObject[childrenArray[i]['.key']]['.key']
        }
      }

      this.$firebaseRefs.menu.child(parent['.key']).child('children').set(childrenObject)
    },
    moveSubLinkDown (currentKey, parent) {
      let childrenObject = {}
      let childrenArray = this.convertFirebaseObjToArray(parent.children)
      let nextKey = ''

      for (let i = childrenArray.length - 1; i >= 0; i--) {
        if (childrenArray[i]['.key'] === currentKey) {
          nextKey = childrenArray[i + 1]['.key']

          childrenObject[nextKey] = {...childrenArray[i]}
          childrenObject[currentKey] = {...childrenArray[i + 1]}

          delete childrenObject[nextKey]['.key']
          delete childrenObject[currentKey]['.key']
        } else {
          childrenObject[childrenArray[i]['.key']] = {...childrenArray[i]}
          delete childrenObject[childrenArray[i]['.key']]['.key']
        }
      }

      this.$firebaseRefs.menu.child(parent['.key']).child('children').set(childrenObject)
    },
    convertFirebaseObjToArray (obj) {
      let array = []
      for (let key in obj) {
        array.push({'.key': key, ...obj[key]})
      }
      return array
    },
    removeSubLink (key, parent) {
      this.$firebaseRefs.menu.child(parent['.key']).child('children').child(key).remove()
    },
    editSubLink (key, parent) {
      this.name = parent.children[key].name
      this.path = parent.children[key].path
      this.action = 'edit-sub'
      this.key = key
      this.link = Object.assign({}, parent)
    },
    updateSubLink () {
      this.$firebaseRefs.menu.child(this.link['.key']).child('children').child(this.key).update({
        name: this.name,
        path: this.path,
        isAbsolute: this.isAbsolute
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.section{
  padding: 0 !important;
  padding-top: 1em !important;
}
.bulma .card .card-content.principal{
  padding: 0 !important;
}
.bulma .card-content{
  padding: 0 !important;
}
.bulma .columns{
  padding: 0 !important;
}
.bulma .column{
  padding: 0 !important;
}
.content{
  padding: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/pages/settings/NavBuilder.vue